
import head from '../../mixins/MetaHead'
import InfoParser from '~/fc/InfoParser'
import { loadMomentTimeZone } from '~/fc/ExternalScripts'
import { getTimeData } from '~/fc/Dal/TimeRepo'
import TimeConverter from /* webpackChunkName: "TimeConverter" */ '~/layouts/partials/time/TimeConverter'

export default {
    name: 'ConverterPage',
    components: {
        TimeConverter,
        TimeChart: () => import(/* webpackChunkName: "TimeChart" */ '../../layouts/partials/time/TimeChart'),
        Alert: () => import(/* webpackChunkName: "Alert" */ '../../components/ui/Alert'),
        ContentCard: () => import(/* webpackChunkName: "ContentCard" */ '../../components/content/ContentCard'),
        ContentCardHTML: () => import(/* webpackChunkName: "ContentCardHtml" */ '../../components/content/ContentCardHTML'),
        AdsSide: () => import(/* webpackChunkName: "AdsSide" */ '../../layouts/partials/ads/AdsSide'),
        AdInPage: () => import(/* webpackChunkName: "AdInPage" */ '../../layouts/partials/ads/AdInPage'),
        TryFree: () => import(/* webpackChunkName: "TryFree" */ '../../layouts/partials/page/TryFree'),
        SecurityAndCompliance: () => import(/* webpackChunkName: "SecurityAndCompliance" */ "~/components/ui/SecurityAndCompliance")
    },
    mixins: [head],
    async asyncData({ params, error, store, route, redirect, app }) {
        const id = params.id
        try {
            const data = await getTimeData(id, store, app.i18n.locale)
            if (!data) { error({ statusCode: 404, message: 'Page not found' }) }

            store.commit('updateBreadcrumbs', [
                {
                    url: '/time/' + id,
                    label: data.header_h1
                }
            ])
            const sourceLists = []
            const targetLists = []
            const total = {}
            let i = 0
            const slugs = Object.keys(data.list)

            slugs.forEach((slug, index) => {
                if (total[i] === undefined) { total[i] = 0 } else { total[i]++ }

                if (!sourceLists[i]) {
                    sourceLists.push([])
                    targetLists.push([])
                }
                if (data.source.slug !== slug) {
                    sourceLists[i].push({
                        url: `/time/${data.source.slug}-to-${slug}`,
                        label: `${data.source.abbr} to ${data.list[slug]}`
                    })
                }
                if (data.target.slug !== slug) {
                    targetLists[i].push({
                        url: `/time/${slug}-to-${data.target.slug}`,
                        label: `${data.list[slug]} to ${data.target.abbr}`
                    })
                }

                if (total[i] > slugs.length / 3 - 1) { i++ }
            })

            return {
                info: data,
                title: data.title,
                desc: data.desc,
                currentUrl: `/time/${id}`,
                source: data.source,
                target: data.target,
                sourceLists,
                targetLists
            }
        } catch (err) {
            error({ statusCode: 404, message: 'Page not found', error: err })
        }
    },
    data: () => ({
        id: '',
        datetime: '',
        target: '',
        source: '',
        mainCardText: '',
        baseUrl: '',
        fullDateFormat: 'MMMM Do YYYY, h:mm:ss a',
        timer: null,
        hours: [],
        sourceLists: [],
        targetLists: [],
        moment: null,
        info: null
    }),
    computed: {
        isMobile() { return this.$store.state.store.isMobile },
        sourceConversionList() {
            if (!this.source || !this.sourceLists) { return [] }
            return [
                {
                    type: 'title',
                    value: this.$t('time_converter_other_zone_title').replace('TIME', this.source.abbr)
                },
                {
                    type: 'paragraph',
                    value: this.$t('time_converter_other_zone_desc').replace('TIME', this.source.abbr)
                },
                {
                    type: 'list',
                    value: {
                        column: this.isMobile ? 2 : 3,
                        items: (new InfoParser(this)).getTimezoneDisplayList(this.sourceLists.flat(), this)
                    }
                }
            ]
        },
        targetConversionList() {
            if (!this.target || !this.targetLists) { return [] }
            return [
                {
                    type: 'title',
                    value: this.$t('time_converter_other_zone_title').replace('TIME', this.target.abbr)
                },
                {
                    type: 'paragraph',
                    value: this.$t('time_converter_other_zone_desc').replace('TIME', this.target.abbr)
                },
                {

                    type: 'list',
                    value: {
                        column: this.isMobile ? 2 : 3,
                        items: (new InfoParser(this)).getTimezoneDisplayList(this.targetLists.flat(), this)
                    }
                }
            ]
        }
    },
    mounted() {
        loadMomentTimeZone((moment) => {
            this.moment = moment
            this.timer = setInterval(() => {
                const contentMarkUp = this.info.main_card_text && this.info.main_card_text[0] ? this.info.main_card_text[0].content : ''
                this.mainCardText = contentMarkUp.replace(
                    /S_FORMATED/g,
                    this.moment.tz(this.moment(), this.source.name).format(this.fullDateFormat)
                )
                    .replace(
                        /T_FORMATED/g,
                        this.moment.tz(this.moment(), this.target.name).format(this.fullDateFormat)
                    )
            }, 1000)
        })
    }
}
